import { FilterType } from '@/hooks/useLobbyUI';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
export const BET_SUMMARY_KEY = 'app::report::summary';

export type BetRecord = {
    BetAmount: number;
    BetID: number;
    BetTime: string;
    BetType: number;
    GameID: number;
    Reason: string;
    Remark: string;
    ResultAmount: number;
    RollingAmount: number;
    Time: string;
};

export type Summary = {
    GameID: number;
    GameCount: number;
    Shoes: number;
    Round: number;
    GameType: number;
    HostID: number;
    ReportDate: string;
    ResultAmount: number;
    RollingAmount: number;
    BetAmount: number;
    WinSlot: number;
    Result: string;
    State: number;
};

export type BetSummaryState = {
    summaries: Array<Summary>;
    successBetRecords: Array<BetRecord>;
    unsuccessBetRecords: Array<BetRecord>;
    selectedFilterType: FilterType;
    allGameType: number;
};

const updateSummary = (
    state: BetSummaryState,
    actions: PayloadAction<{ summaries: BetSummaryState['summaries'] }>
) => {
    state.summaries = actions.payload.summaries;

    const summaries = actions.payload.summaries;
    let allGameType = 0;
    for (let s of summaries) {
        allGameType = allGameType | s.GameType;
    }
    state.allGameType = allGameType;
};

const updateBetRecord = (
    state: BetSummaryState,
    actions: PayloadAction<{
        successBetRecords: BetSummaryState['successBetRecords'];
        unsuccessBetRecords: BetSummaryState['unsuccessBetRecords'];
    }>
) => {
    state.successBetRecords = actions.payload.successBetRecords;
    state.unsuccessBetRecords = actions.payload.unsuccessBetRecords;
};
const updateSelectedFilterType = (
    state: BetSummaryState,
    actions: PayloadAction<number>
) => {
    state.selectedFilterType = actions.payload;
};

const reset = (state: BetSummaryState) => {
    state.summaries = initialBetSummary.summaries;
    state.successBetRecords = initialBetSummary.successBetRecords;
    state.unsuccessBetRecords = initialBetSummary.unsuccessBetRecords;
    state.selectedFilterType = initialBetSummary.selectedFilterType;
    state.allGameType = initialBetSummary.allGameType;
};

const initialBetSummary = {} as BetSummaryState;
const betSummarySlice = createSlice({
    name: BET_SUMMARY_KEY,
    initialState: initialBetSummary,
    reducers: {
        updateSummary,
        updateSelectedFilterType,
        updateBetRecord,
        reset,
    },
});
export const betSummarySliceReducer = betSummarySlice.reducer;
export const betSummarySliceActions = betSummarySlice.actions;
